import { createContext } from 'utils/react';

export default createContext('Selectable', {});
